/* Filtrous PDP merchandising flow - v9.4, 2026-08-26 (Adelaide, Revolve PDP
   as the reference; v1-v9.2 same day, see the tail of this header for the
   fix log).
   v9.4: EVERY protocol card now carries a working action (Adelaide: "make
   sure that the complete the protocol cards all work and can be added to
   cart"). Three holes are closed: (a) an OSK quote item could be picked
   into the rail and rendered with NO action row at all - it now gets a
   "Request a Quote" link to the contact page, the same treatment the
   storefront widget cards use; (b) cards restored from the sessionStorage
   arrangement or the localStorage winner carry a price/stock SNAPSHOT, so
   an item that sold out since could render an Add to cart that 422s -
   pruneProtoCards() drops any cached card the live index no longer shows
   as available (the live-stock shim rewrites that flag before the index
   resolves, so it is current); (c) a failed add said "Try again" even when
   the answer was 422 sold out - it now says Sold out and stays disabled.
   v9.3: the quick-view affordance is now Revolve's BAR (Adelaide, with the
   Chaya Capri card as the reference: "i really like this quick view button
   if I hover over it") - a wide translucent QUICK VIEW bar centred across
   the card image on hover/focus, not a small pill.
   v9.2: QUICK VIEW (Adelaide: "there should be a quick view option") -
   every rail card (Recommended / Recently viewed link cards AND the
   protocol pcards, the app's own included) gets the bar on its image:
   hover/focus reveals it on pointer devices, always visible on touch. The
   bar carries data-fqv-handle; the shared modal
   (assets/filtrous-quick-view.js, loaded via the cart-drawer snippet)
   intercepts the click and opens without navigating. Bars only render once
   window.FV3_QUICKVIEW exists, so a removed modal asset leaves no dead
   buttons. Reveal transition is reduced-motion-gated.
   v9.1: the WORKFLOW / UPSELL / KIT_FAMS maps live in
   assets/filtrous-merch-maps.js (window.FV3_MERCH), shared with the
   cart-drawer suggestions; missing maps degrade to API-order recs.
   STICKY CHROME (v5/v5.2): .fv3-top + breadcrumb pin (desktop); gallery
   offset clears both (164px).
   Buy column: buy block -> Net-30 -> [ Description | Specifications ] TABS
   -> Complete The Protocol. Below the grid: Recommended For You, then
   Recently viewed.
   1) TABS with compact spec bullets (light markers).
   2) COMPLETE THE PROTOCOL (v9): NO ALTERNATIVES - the app's same-family
      pairs cards are hidden; the appended extras are REAL pcards with a
      working stepper + add-to-cart (variant id from the catalog index,
      POST /cart/add.js, header count refreshed; OSK quote items link-only).
      Order: price-anchored kit UPSELL first ("Full kit" badge), then the
      seeded-scramble workflow outfit. 6 extras.
   3) RECOMMENDED FOR YOU: six cards - upsell first, then picks ranked by
      the visitor's own signals (purchases x3 via filtrous-recs-signals,
      recently viewed x2, dwell/clicks; browser-scoped, NOT IP-based);
      discovery-only; the current product's family is EXCLUDED entirely;
      cold start falls back to workflow companions.
   v7 UPSELL: price-anchored (closest above the anchor first); both rails
   lead with 1-2 upsell cards; workflow fallback above the anchor when a
   family has no kit.
   v8 EXPLORE/EXPLOIT + SESSION STABILITY: seeded scramble + per-product
   sessionStorage caches; a NEW session re-deals; first rail ENGAGEMENT
   locks the arrangement as that product's winner (newest 30 kept). True
   conversion optimization still needs order-level attribution (?src=
   keys). Cache/winner keys: -x2-/-v2.
   4) ARROWS (v5): labeled prev/next buttons, end-disabled, overflow-gated,
      reduced-motion-aware; each pair watches its rail for async growth.
   5) ORDER: .fv3-rec after the grid; .fv3-rv LAST.
   Rail/card CSS deliberately DUPLICATES filtrous-recently-viewed.js
   (.fv3-rv-*) so either asset is independently removable - keep in sync.
   Fix log: v2.1 spec-shell claimed only once its table renders. v2.2 h2
   re-drop each pass. v3 a11y/motion baseline. v3.1 min-width:0 buy column.
   v4.1 spec header-row skip. v4.2 light bullets. v5.3.1 same-family
   reserve (superseded by v6 rail swap). v8.1 Net-30 -> tabs gap 16px.
   Additive asset; remove its loader line in sections/filtrous-v3-app.liquid
   to revert (fv3-* storage keys just go unread). */
(function () {
  'use strict';

  var cfg = window.FV3_CONFIG || {};
  var pid = cfg.pdpProductId;
  var curMatch = location.pathname.match(/\/products\/([^\/?#]+)/);
  var HANDLE = curMatch ? curMatch[1] : '';

  /* v9.1: shared relations - see assets/filtrous-merch-maps.js */
  var MM = window.FV3_MERCH || {};
  var WORKFLOW = MM.WORKFLOW || {};
  var UPSELL = MM.UPSELL || {};
  var KIT_FAMS = MM.KIT_FAMS || {};

  var css = document.createElement('style');
  css.textContent =
    '#fv3-app .fv3-top{position:sticky;top:0;z-index:120;background:#fff;box-shadow:0 1px 0 var(--line,#e3e9ee)}' +
    '@media (min-width:701px){' +
      '#fv3-app .fv3-pdp-top{position:sticky;top:114px;z-index:110;background:#f4f6f8;margin-top:0;padding-top:8px;padding-bottom:8px}' +
      '#fv3-app .fv3-pdp-grid > .fv3-gallery{position:sticky;top:164px}' +
    '}' +
    '#fv3-app .fv3-buy .fv3-about{margin-top:16px}' +
    '#fv3-app .fv3-pdp-grid .fv3-buy{min-width:0}' +
    '#fv3-app .fv3-tabrow{display:flex;gap:22px;border-bottom:1px solid var(--line,#e3e9ee);margin:0 0 14px}' +
    '#fv3-app .fv3-tab{border:0;background:none;padding:0 2px 9px;font:inherit;font-size:15px;font-weight:700;color:var(--mut,#5b7284);cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1px}' +
    '#fv3-app .fv3-tab:hover{color:var(--navy,#082f4b)}' +
    '#fv3-app .fv3-tab[aria-selected="true"]{color:var(--navy,#082f4b);border-bottom-color:var(--dteal,#0d7d68)}' +
    '#fv3-app .fv3-tabpanel-specs .fv3-specs-wrap{width:100%;overflow-x:auto}' +
    '#fv3-app .fv3-tabpanel-specs table{width:100%;margin-top:0}' +
    '#fv3-app .fv3-tabpanel-specs .fv3-spec-bullets{margin:0;padding:0 0 0 18px;list-style:disc}' +
    '#fv3-app .fv3-tabpanel-specs .fv3-spec-bullets li{font-size:13.5px;line-height:1.45;color:var(--ink,#082f4b);margin:0 0 6px}' +
    '#fv3-app .fv3-tabpanel-specs .fv3-spec-bullets li::marker{color:#c3cdd5}' +
    '#fv3-app .fv3-tabpanel-specs .fv3-spec-bullets li b{font-weight:600;color:var(--navy,#082f4b)}' +
    '#fv3-app .fv3-buy .fv3-pairs{margin-top:26px;padding-top:20px;max-width:100%;position:relative}' +
    '#fv3-app .fv3-buy .fv3-pairs-row{display:grid;grid-auto-flow:column;grid-auto-columns:172px;grid-template-columns:none;gap:12px;overflow-x:auto;padding:2px 2px 10px;-webkit-overflow-scrolling:touch}' +
    '#fv3-app .fv3-buy .fv3-pcard .pc-actions{padding:0 10px 10px;gap:6px}' +
    '#fv3-app .fv3-buy .fv3-pcard .pc-step button{width:22px}' +
    '#fv3-app .fv3-buy .fv3-pcard .pc-step b{min-width:24px}' +
    '#fv3-app .fv3-buy .fv3-pcard .pc-add{font-size:11.5px}' +
    /* v9.4: quote items are not addable - give them the quote CTA instead */
    '#fv3-app .fv3-pairs .pc-quote{flex:1 1 auto;display:block;text-align:center;text-decoration:none;background:rgba(33,214,179,.14);color:var(--navy,#082f4b);border:1px solid rgba(33,214,179,.5);border-radius:7px;font-size:11px;font-weight:700;padding:7px 6px;line-height:1.2}' +
    '#fv3-app .fv3-pairs .pc-quote:hover{background:rgba(33,214,179,.24)}' +
    '#fv3-app .fv3-pairs .pc-add:disabled{background:#e3e9ee;color:#8496a3;cursor:default}' +
    '#fv3-app .fv3-pcard .pc-img{position:relative}' +
    '#fv3-app .fv3-buy .fv3-pairs-row,#fv3-app .fv3-rv-rail{scrollbar-width:thin;scrollbar-color:#b9c6cf #eef2f5}' +
    '#fv3-app .fv3-buy .fv3-pairs-row::-webkit-scrollbar,#fv3-app .fv3-rv-rail::-webkit-scrollbar{height:8px}' +
    '#fv3-app .fv3-buy .fv3-pairs-row::-webkit-scrollbar-track,#fv3-app .fv3-rv-rail::-webkit-scrollbar-track{background:#eef2f5;border-radius:4px}' +
    '#fv3-app .fv3-buy .fv3-pairs-row::-webkit-scrollbar-thumb,#fv3-app .fv3-rv-rail::-webkit-scrollbar-thumb{background:#b9c6cf;border-radius:4px}' +
    '#fv3-app .fv3-buy .fv3-pairs-row:focus-visible,#fv3-app .fv3-rv-rail:focus-visible{outline:2px solid var(--dteal,#0d7d68);outline-offset:2px}' +
    '#fv3-app .fv3-arrows{display:inline-flex;gap:6px}' +
    '#fv3-app .fv3-rv-head .fv3-arrows{margin-left:auto}' +
    '#fv3-app .fv3-arrows + .fv3-rv-clear{margin-left:12px}' +
    '#fv3-app .fv3-buy .fv3-pairs > .fv3-arrows{position:absolute;top:14px;right:2px}' +
    '#fv3-app .fv3-arrows button{width:28px;height:28px;border-radius:50%;border:1px solid var(--line,#e3e9ee);background:#fff;color:var(--navy,#082f4b);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;padding:0}' +
    '#fv3-app .fv3-arrows button:hover:not(:disabled){border-color:rgba(33,214,179,.55);color:var(--dteal,#0d7d68)}' +
    '#fv3-app .fv3-arrows button:disabled{opacity:.35;cursor:default}' +
    '#fv3-app .fv3-arrows button:focus-visible{outline:2px solid var(--dteal,#0d7d68);outline-offset:2px}' +
    '#fv3-app .fv3-rec{margin:44px 0 8px;border-top:1px solid var(--line,#e3e9ee);padding-top:22px}' +
    '#fv3-app .fv3-rv-head{display:flex;align-items:baseline;gap:14px;margin:0 0 14px}' +
    '#fv3-app .fv3-rv-head h2{margin:0;font-size:18px;font-weight:700;letter-spacing:-.01em;color:var(--navy,#082f4b)}' +
    '#fv3-app .fv3-rv-rail{display:grid;grid-auto-flow:column;grid-auto-columns:224px;gap:14px;overflow-x:auto;padding:2px 2px 10px;-webkit-overflow-scrolling:touch}' +
    '#fv3-app .fv3-rv-card{display:flex;flex-direction:column;background:#fff;border:1px solid var(--line,#e3e9ee);border-radius:10px;padding:12px;color:inherit;text-decoration:none}' +
    '#fv3-app .fv3-rv-card:hover{border-color:rgba(33,214,179,.45);box-shadow:0 4px 16px rgba(8,47,75,.08)}' +
    '#fv3-app .fv3-buy .fv3-pairs-row .fv3-rv-card{padding:10px}' +
    '@media (prefers-reduced-motion: no-preference){' +
      '#fv3-app .fv3-rv-card{transition:border-color .15s,box-shadow .15s,transform .15s}' +
      '#fv3-app .fv3-rv-card:hover{transform:translateY(-2px)}' +
    '}' +
    '#fv3-app .fv3-rv-img{position:relative;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;background:#fff;border-radius:6px;overflow:hidden;margin-bottom:9px}' +
    '#fv3-app .fv3-rv-img img{max-width:100%;max-height:100%;object-fit:contain}' +
    '#fv3-app .fv3-rv-img:empty{background:var(--panel,#f4f6f8)}' +
    '#fv3-app .fv3-up-badge{position:absolute;top:6px;left:6px;background:rgba(33,214,179,.16);color:var(--dteal,#0d7d68);font-size:10.5px;font-weight:700;letter-spacing:.04em;padding:3px 9px;border-radius:999px;pointer-events:none;z-index:2}' +
    /* v9.3: Revolve-style QUICK VIEW bar across the middle of the card image */
    '#fv3-app .fv3-qv{position:absolute;left:6px;right:6px;top:50%;transform:translateY(-50%);' +
      'border:1px solid rgba(8,47,75,.16);background:rgba(255,255,255,.86);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);' +
      'color:var(--navy,#082f4b);font-family:inherit;font-size:11px;font-weight:700;letter-spacing:.13em;text-transform:uppercase;' +
      'text-align:center;padding:10px 4px;cursor:pointer;opacity:0;pointer-events:none;z-index:3}' +
    '#fv3-app .fv3-rv-card:hover .fv3-qv,#fv3-app .fv3-pcard:hover .fv3-qv,#fv3-app .fv3-qv:focus-visible{opacity:1;pointer-events:auto}' +
    '#fv3-app .fv3-qv:hover{background:#fff;border-color:rgba(8,47,75,.34)}' +
    '#fv3-app .fv3-qv:focus-visible{outline:2px solid var(--dteal,#0d7d68);outline-offset:1px}' +
    '#fv3-app .fv3-buy .fv3-pairs .fv3-qv{font-size:10px;letter-spacing:.1em;padding:8px 3px}' +
    '@media (prefers-reduced-motion: no-preference){#fv3-app .fv3-qv{transition:opacity .16s,background .16s,border-color .16s}}' +
    '@media (hover:none){#fv3-app .fv3-qv{opacity:1;pointer-events:auto}}' +
    '#fv3-app .fv3-rv-t{font-size:13px;font-weight:600;line-height:1.35;color:var(--ink,#082f4b);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin-bottom:4px}' +
    '#fv3-app .fv3-rv-sku{font-size:12px;color:var(--mut,#5b7284);margin-bottom:6px}' +
    '#fv3-app .fv3-rv-p{margin-top:auto;font-size:14px;font-weight:700;color:var(--navy,#082f4b)}' +
    '@media (max-width:700px){#fv3-app .fv3-rec{margin-top:34px}#fv3-app .fv3-rv-rail{grid-auto-columns:180px}}';
  document.head.appendChild(css);

  function pickUpsells(map, curIt, excluded, maxN) {
    if (!map || !curIt) return [];
    var anchor = parseFloat(curIt.price) || 0;
    function collect(famList) {
      var out = [];
      if (!famList || !famList.length) return out;
      for (var h in map) {
        var it = map[h];
        if (!it || !it.available || excluded[h]) continue;
        if (famList.indexOf(it.primary_family) === -1) continue;
        out.push(it);
      }
      return out;
    }
    var pool = collect(UPSELL[curIt.primary_family]);
    if (!pool.length) pool = collect(WORKFLOW[curIt.primary_family]).filter(function (it) { return parseFloat(it.price) > anchor; });
    function priceOf(it) { var n = parseFloat(it.price); return isFinite(n) ? n : 0; }
    var above = pool.filter(function (it) { return priceOf(it) > anchor; }).sort(function (a, b) { return priceOf(a) - priceOf(b); });
    var below = pool.filter(function (it) { return priceOf(it) <= anchor; }).sort(function (a, b) { return priceOf(b) - priceOf(a); });
    return above.concat(below).slice(0, maxN);
  }

  /* ---- v8: session seed, seeded shuffle, per-product caches, winners ---- */
  function sessionSeed() {
    var s = null;
    try { s = sessionStorage.getItem('fv3-seed'); } catch (e) {}
    if (!s) {
      s = String(Math.floor(Math.random() * 1e9));
      try { sessionStorage.setItem('fv3-seed', s); } catch (e) {}
    }
    return s;
  }
  function randFor(handle) {
    var str = sessionSeed() + '|' + handle, t = 0;
    for (var i = 0; i < str.length; i++) t = (t * 31 + str.charCodeAt(i)) | 0;
    t = t >>> 0;
    return function () {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ t >>> 15, 1 | t);
      r = r + Math.imul(r ^ r >>> 7, 61 | r) ^ r;
      return ((r ^ r >>> 14) >>> 0) / 4294967296;
    };
  }
  function shuffle(arr, rand) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
  }
  var WIN_KEY = 'fv3-rail-winners-v2';
  function loadWinners() {
    try { var o = JSON.parse(localStorage.getItem(WIN_KEY) || '{}'); return o && typeof o === 'object' ? o : {}; }
    catch (e) { return {}; }
  }
  function loadCache(kind, handle) {
    var w = loadWinners()[handle];
    if (w && w[kind] && w[kind].length) return w[kind];
    try {
      var s = JSON.parse(sessionStorage.getItem('fv3-' + kind + '-x2-' + handle) || 'null');
      return (s && s.length) ? s : null;
    } catch (e) { return null; }
  }
  function saveCache(kind, handle, list) {
    function write() { try { sessionStorage.setItem('fv3-' + kind + '-x2-' + handle, JSON.stringify(list)); } catch (e) {} }
    if (document.prerendering) document.addEventListener('prerenderingchange', write, { once: true });
    else write();
  }
  function markWinner(handle) {
    if (!handle) return;
    var w = loadWinners();
    if (w[handle] && w[handle].locked) return;
    var proto = null, rec = null;
    try { proto = JSON.parse(sessionStorage.getItem('fv3-proto-x2-' + handle) || 'null'); } catch (e) {}
    try { rec = JSON.parse(sessionStorage.getItem('fv3-rec-x2-' + handle) || 'null'); } catch (e) {}
    if (!proto && !rec) return;
    w[handle] = { t: Date.now(), locked: 1, proto: proto || [], rec: rec || [] };
    var keys = Object.keys(w);
    if (keys.length > 30) {
      keys.sort(function (a, b) { return (w[a].t || 0) - (w[b].t || 0); });
      keys.slice(0, keys.length - 30).forEach(function (k) { delete w[k]; });
    }
    try { localStorage.setItem(WIN_KEY, JSON.stringify(w)); } catch (e) {}
  }

  /* ---- read-only catalog-index tap ---- */
  var indexByHandle = null;
  var indexWaiters = [];
  function onIndex(cb) { if (indexByHandle) cb(indexByHandle); else indexWaiters.push(cb); }
  (function () {
    var orig = window.fetch;
    if (!orig) return;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (String(url).indexOf('catalog-index') !== -1) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          return res.clone().json().then(function (data) {
            var list = data && data.products;
            if (!list || !list.length) return;
            var map = {};
            list.forEach(function (it) { if (it && it.handle && !map[it.handle]) map[it.handle] = it; });
            indexByHandle = map;
            indexWaiters.splice(0).forEach(function (cb) { try { cb(map); } catch (e) {} });
          });
        }).catch(function () {});
      }
      return p;
    };
  })();

  /* ---- behavioral affinity ---- */
  var AFF_KEY = 'fv3-affinity-v1';
  function loadAff() {
    try { var o = JSON.parse(localStorage.getItem(AFF_KEY) || '{}'); return o && typeof o === 'object' ? o : {}; }
    catch (e) { return {}; }
  }
  function bumpFamilies(fams, w) {
    if (!fams || !fams.length) return;
    var o = loadAff(), max = 0;
    fams.forEach(function (f) { o[f] = (o[f] || 0) + w; if (o[f] > max) max = o[f]; });
    if (max > 50) Object.keys(o).forEach(function (k) { o[k] = Math.floor(o[k] / 2); if (!o[k]) delete o[k]; });
    try { localStorage.setItem(AFF_KEY, JSON.stringify(o)); } catch (e) {}
  }
  function startBehaviorTracking() {
    if (HANDLE) {
      setTimeout(function () {
        if (document.visibilityState !== 'visible') return;
        onIndex(function (map) { var it = map[HANDLE]; if (it) bumpFamilies(it.families, 2); });
      }, 15000);
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#fv3-app .fv3-pairs .fv3-pcard, #fv3-app .fv3-rec .fv3-rv-card')) markWinner(HANDLE);
      var a = t.closest('#fv3-app .fv3-rv-card, #fv3-app .fv3-pcard a');
      if (!a) return;
      var mm = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!mm) return;
      onIndex(function (map) { var it = map[mm[1]]; if (it) bumpFamilies(it.families, 3); });
    }, true);
  }
  if (document.prerendering) document.addEventListener('prerenderingchange', startBehaviorTracking, { once: true });
  else startBehaviorTracking();

  /* ---- rail arrows (v5) ---- */
  function motionOK() { return window.matchMedia('(prefers-reduced-motion: no-preference)').matches; }
  function chev(dir) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 16 16'); s.setAttribute('width', '14'); s.setAttribute('height', '14');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round'); s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', dir < 0 ? 'M10 12L6 8l4-4' : 'M6 4l4 4-4 4');
    s.appendChild(p);
    return s;
  }
  function armArrows(rail, label, mount, before) {
    if (!rail || !mount || rail.getAttribute('data-fv-arrows')) return;
    rail.setAttribute('data-fv-arrows', '1');
    var wrap = document.createElement('div');
    wrap.className = 'fv3-arrows';
    function mkBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Scroll ' + label + ' ' + (dir < 0 ? 'backward' : 'forward'));
      b.appendChild(chev(dir));
      b.addEventListener('click', function () {
        rail.scrollBy({ left: dir * Math.max(rail.clientWidth * 0.8, 180), behavior: motionOK() ? 'smooth' : 'auto' });
      });
      return b;
    }
    var prev = mkBtn(-1), next = mkBtn(1);
    wrap.appendChild(prev); wrap.appendChild(next);
    function update() {
      if (!rail.isConnected) return;
      wrap.style.display = rail.scrollWidth > rail.clientWidth + 2 ? '' : 'none';
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    try { new MutationObserver(update).observe(rail, { childList: true }); } catch (e) {}
    if (before) mount.insertBefore(wrap, before); else mount.appendChild(wrap);
    update();
    setTimeout(update, 400);
  }
  function ensureArrows(pdp) {
    var pr = pdp.querySelector('.fv3-buy .fv3-pairs-row');
    if (pr) armArrows(pr, 'Complete The Protocol', pr.closest('.fv3-pairs'), null);
    [].slice.call(pdp.querySelectorAll('.fv3-rec, .fv3-rv')).forEach(function (sec) {
      var rail = sec.querySelector('.fv3-rv-rail');
      var head = sec.querySelector('.fv3-rv-head');
      if (!rail || !head) return;
      var label = sec.classList.contains('fv3-rec') ? 'Recommended For You' : 'Recently viewed';
      armArrows(rail, label, head, head.querySelector('.fv3-rv-clear'));
    });
  }

  /* ---- v9.2/9.3: quick-view bar on every rail card ---- */
  function ensureQuickViewBars(pdp) {
    if (!window.FV3_QUICKVIEW) return;   // modal asset absent -> no dead buttons
    var cards = pdp.querySelectorAll('.fv3-rv-card:not([data-fqv-armed]), .fv3-pairs .fv3-pcard:not([data-fqv-armed])');
    [].slice.call(cards).forEach(function (cardEl) {
      cardEl.setAttribute('data-fqv-armed', '1');
      var a = cardEl.matches('a') ? cardEl : cardEl.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var imgBox = cardEl.querySelector('.fv3-rv-img, .pc-img');
      if (!imgBox) return;
      var title = (cardEl.querySelector('.fv3-rv-t, .pc-t') || {}).textContent || '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fv3-qv';
      b.textContent = 'Quick view';   // CSS uppercases it; the accessible name stays natural
      b.setAttribute('data-fqv-handle', m[1]);
      b.setAttribute('aria-label', 'Quick view: ' + title);
      imgBox.appendChild(b);
    });
  }

  /* ---- tabs ---- */
  function selectTab(about, which) {
    var tabs = about.querySelectorAll('.fv3-tab');
    var panels = { desc: about.querySelector('.fv3-about-body'), specs: about.querySelector('.fv3-tabpanel-specs') };
    [].slice.call(tabs).forEach(function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-tab') === which ? 'true' : 'false');
    });
    Object.keys(panels).forEach(function (k) {
      if (panels[k]) panels[k].hidden = (k !== which);
    });
  }
  function tabButton(about, label, key) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fv3-tab';
    b.setAttribute('role', 'tab');
    b.setAttribute('data-tab', key);
    b.setAttribute('aria-selected', key === 'desc' ? 'true' : 'false');
    b.textContent = label;
    b.addEventListener('click', function () { selectTab(about, key); });
    return b;
  }
  function buildSpecBullets(panel) {
    if (panel.querySelector('.fv3-spec-bullets')) return;
    var tbl = panel.querySelector('table');
    if (!tbl) return;
    var ul = document.createElement('ul');
    ul.className = 'fv3-spec-bullets';
    [].slice.call(tbl.querySelectorAll('tr')).forEach(function (tr) {
      if (tr.querySelector('th') || (tr.parentElement && tr.parentElement.tagName === 'THEAD')) return;
      var cells = tr.children;
      if (!cells.length) return;
      var label = cells[0].textContent.replace(/\s+/g, ' ').trim();
      var value = cells.length > 1 ? cells[1].textContent.replace(/\s+/g, ' ').trim() : '';
      if (!label && !value) return;
      if (label === 'Specification' && value === 'Value') return;
      var li = document.createElement('li');
      if (label && value) {
        var b = document.createElement('b');
        b.textContent = label + ': ';
        li.appendChild(b);
        li.appendChild(document.createTextNode(value));
      } else {
        li.textContent = label || value;
      }
      ul.appendChild(li);
    });
    if (!ul.children.length) return;
    panel.insertBefore(ul, panel.firstChild);
    var wrap = panel.querySelector('.fv3-specs-wrap');
    if (wrap) wrap.hidden = true;
  }
  function ensureTabs(pdp) {
    var about = pdp.querySelector('.fv3-buy .fv3-about');
    if (!about) return;
    [].slice.call(about.children).forEach(function (c) { if (c.tagName === 'H2') c.remove(); });
    var row = about.querySelector('.fv3-tabrow');
    if (!row) {
      row = document.createElement('div');
      row.className = 'fv3-tabrow';
      row.setAttribute('role', 'tablist');
      row.appendChild(tabButton(about, 'Description', 'desc'));
      about.insertBefore(row, about.firstChild);
      var body = about.querySelector('.fv3-about-body');
      if (body) body.setAttribute('role', 'tabpanel');
    }
    var specsSec = pdp.querySelector('.fv3-specs-sec');
    if (specsSec) {
      var wrap = specsSec.querySelector('.fv3-specs-wrap');
      if (wrap && wrap.querySelector('table')) {
        var panel = about.querySelector('.fv3-tabpanel-specs');
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'fv3-tabpanel-specs';
          panel.setAttribute('role', 'tabpanel');
          panel.hidden = true;
          about.appendChild(panel);
          row.appendChild(tabButton(about, 'Specifications', 'specs'));
        }
        panel.appendChild(wrap);
        specsSec.remove();
      }
    }
    var specPanel = about.querySelector('.fv3-tabpanel-specs');
    if (specPanel) buildSpecBullets(specPanel);
  }

  /* ---- card builders ---- */
  function isQuoteSku(sku) { var s = String(sku || '').toUpperCase(); return s.indexOf('OSK') !== -1 || /^(EXK|MDA|MDB|MNA|MNB|MXA)-/.test(s); }
  function fmtCents(cents, sku) {
    return isQuoteSku(sku) ? 'Call for Quote' : (isFinite(cents) ? '$' + (cents / 100).toFixed(2) : '');
  }
  function normApi(p) {
    return {
      handle: p.handle,
      title: p.title || '',
      image: p.featured_image || (p.images && p.images[0]) || '',
      cents: p.price,
      sku: (p.variants && p.variants[0] && p.variants[0].sku) || ''
    };
  }
  function normIdx(it) {
    var n = parseFloat(it.price);
    return { handle: it.handle, title: it.title || '', image: it.image || '', cents: isFinite(n) ? Math.round(n * 100) : NaN, sku: it.sku || '', vid: it.vid || '' };
  }
  function card(c, badge) {
    var a = document.createElement('a');
    a.className = 'fv3-rv-card';
    a.href = '/products/' + c.handle;
    var box = document.createElement('div');
    box.className = 'fv3-rv-img';
    if (c.image) {
      var img = document.createElement('img');
      img.src = c.image;
      img.alt = c.title;
      img.loading = 'lazy';
      box.appendChild(img);
    }
    if (badge) {
      var bd = document.createElement('span');
      bd.className = 'fv3-up-badge';
      bd.textContent = badge;
      box.appendChild(bd);
    }
    a.appendChild(box);
    var t = document.createElement('div');
    t.className = 'fv3-rv-t';
    t.textContent = c.title;
    a.appendChild(t);
    if (c.sku) {
      var s = document.createElement('div');
      s.className = 'fv3-rv-sku';
      s.textContent = c.sku;
      a.appendChild(s);
    }
    var pr = document.createElement('div');
    pr.className = 'fv3-rv-p';
    pr.textContent = fmtCents(c.cents, c.sku);
    a.appendChild(pr);
    return a;
  }
  function protoCard(o) {
    var d = document.createElement('div');
    d.className = 'fv3-pcard';
    d.setAttribute('data-fv-handle', o.handle);   // v9.4: pruneProtoCards() reads this
    var a = document.createElement('a');
    a.className = 'pc-link';
    a.href = '/products/' + o.handle;
    var im = document.createElement('div');
    im.className = 'pc-img';
    if (o.image) {
      var img = document.createElement('img');
      img.src = o.image;
      img.alt = '';
      img.loading = 'lazy';
      im.appendChild(img);
    }
    if (o.badge) {
      var bd = document.createElement('span');
      bd.className = 'fv3-up-badge';
      bd.textContent = o.badge;
      im.appendChild(bd);
    }
    a.appendChild(im);
    var body = document.createElement('div');
    body.className = 'pc-body';
    var t = document.createElement('div');
    t.className = 'pc-t';
    t.textContent = o.title;
    body.appendChild(t);
    if (o.sku) {
      var sk = document.createElement('div');
      sk.className = 'pc-sku';
      sk.appendChild(document.createTextNode('SKU: '));
      var b = document.createElement('b');
      b.textContent = o.sku;
      sk.appendChild(b);
      body.appendChild(sk);
    }
    var pp = document.createElement('div');
    pp.className = 'pc-p';
    pp.textContent = fmtCents(o.cents, o.sku);
    body.appendChild(pp);
    a.appendChild(body);
    d.appendChild(a);
    if (o.vid && !isQuoteSku(o.sku)) {
      var act = document.createElement('div');
      act.className = 'pc-actions';
      var step = document.createElement('div');
      step.className = 'pc-step';
      var qty = 1;
      var dec = document.createElement('button');
      dec.type = 'button'; dec.className = 'dec'; dec.setAttribute('aria-label', 'Decrease quantity'); dec.textContent = '−';
      var num = document.createElement('b');
      num.setAttribute('aria-live', 'polite'); num.textContent = '1';
      var inc = document.createElement('button');
      inc.type = 'button'; inc.className = 'inc'; inc.setAttribute('aria-label', 'Increase quantity'); inc.textContent = '+';
      dec.addEventListener('click', function () { if (qty > 1) { qty--; num.textContent = qty; } });
      inc.addEventListener('click', function () { if (qty < 99) { qty++; num.textContent = qty; } });
      step.appendChild(dec); step.appendChild(num); step.appendChild(inc);
      var add = document.createElement('button');
      add.type = 'button'; add.className = 'pc-add'; add.textContent = 'Add to cart';
      add.addEventListener('click', function () {
        add.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(o.vid), quantity: qty })
        }).then(function (r) {
          if (!r.ok) { var err = new Error('add failed'); err.soldOut = r.status === 422; throw err; }
          add.classList.add('done');
          add.textContent = 'Added ✓';
          setTimeout(function () { add.classList.remove('done'); add.textContent = 'Add to cart'; add.disabled = false; }, 1600);
          return fetch('/cart.js').then(function (cr) { return cr.json(); }).then(function (c) {
            [].slice.call(document.querySelectorAll('.fh3-cart .count, .fv3-actions .count')).forEach(function (el) { el.textContent = c.item_count; });
          });
        }).catch(function (err) {
          if (err && err.soldOut) {   // v9.4: 422 is the cart saying no, not a blip
            add.textContent = 'Sold out';
            add.disabled = true;
            return;
          }
          add.textContent = 'Try again';
          add.disabled = false;
        });
      });
      act.appendChild(step); act.appendChild(add);
      d.appendChild(act);
    } else if (isQuoteSku(o.sku)) {
      /* v9.4: quote items can't be added - but the card must still DO something */
      var qact = document.createElement('div');
      qact.className = 'pc-actions';
      var ql = document.createElement('a');
      ql.className = 'pc-quote';
      ql.href = '/pages/contact?inquiry=quote&product=' + encodeURIComponent(o.title || '') + '&sku=' + encodeURIComponent(o.sku);
      ql.textContent = 'Request a Quote';
      ql.setAttribute('aria-label', 'Request a quote: ' + (o.title || o.sku));
      qact.appendChild(ql);
      d.appendChild(qact);
    }
    return d;
  }
  function upBadge(it) { return KIT_FAMS[it.primary_family] ? 'Full kit' : null; }
  function withBadge(it) { var o = normIdx(it); o.badge = upBadge(it); return o; }

  /* ---- Complete The Protocol ---- */
  var protoExtras = null;
  var protoExtraHandles = {};
  function hideAlternatives(pdp, map) {
    if (!map || !HANDLE || !map[HANDLE]) return;
    var curFam = map[HANDLE].primary_family || '';
    if (!curFam) return;
    [].slice.call(pdp.querySelectorAll('.fv3-pairs .fv3-pcard:not([data-fv-alt-checked])')).forEach(function (pc) {
      pc.setAttribute('data-fv-alt-checked', '1');
      var a = pc.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      var it = m && map[m[1]];
      if (it && (it.primary_family || '') === curFam) pc.style.display = 'none';
    });
  }
  function buildProtoExtras(map) {
    if (protoExtras || !HANDLE) return;
    var cached = loadCache('proto', HANDLE);
    if (cached) {
      protoExtras = cached.map(function (o) { protoExtraHandles[o.handle] = 1; return protoCard(o); });
      return;
    }
    if (!map) return;
    var pdp = document.querySelector('#fv3-app .fv3-pdp');
    if (!pdp) return;
    var curIt = map[HANDLE];
    if (!curIt) { protoExtras = []; return; }
    var skip = {};
    skip[HANDLE] = 1;
    [].slice.call(pdp.querySelectorAll('.fv3-pairs a[href*="/products/"]')).forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (m) skip[m[1]] = 1;
    });
    var ups = pickUpsells(map, curIt, skip, 2);
    ups.forEach(function (it) { skip[it.handle] = 1; });
    var comps = WORKFLOW[curIt.primary_family || ''] || [];
    var buckets = {}, famOrder = [];
    for (var h in map) {
      var it = map[h];
      if (!it || !it.available || skip[h]) continue;
      var pf = it.primary_family;
      if (comps.indexOf(pf) === -1) continue;
      if (!buckets[pf]) { buckets[pf] = []; famOrder.push(pf); }
      if (buckets[pf].length >= 2) continue;
      buckets[pf].push(it);
    }
    shuffle(famOrder, randFor(HANDLE));
    var compCap = 6 - ups.length;
    var out = [], more = true;
    while (more && out.length < compCap) {
      more = false;
      famOrder.forEach(function (f) {
        if (out.length < compCap && buckets[f].length) { out.push(buckets[f].shift()); more = true; }
      });
    }
    var list = ups.map(withBadge).concat(out.map(function (it) { var o = normIdx(it); o.badge = null; return o; }));
    saveCache('proto', HANDLE, list);
    protoExtras = list.map(function (o) { protoExtraHandles[o.handle] = 1; return protoCard(o); });
  }
  /* v9.4: cached / winner arrangements carry a stock snapshot - drop any card
     the live index no longer sells, so no card offers an add that 422s */
  function pruneProtoCards(map) {
    if (!map || !protoExtras) return;
    protoExtras = protoExtras.filter(function (el) {
      var h = el.getAttribute('data-fv-handle');
      var it = h ? map[h] : null;
      var keep = !!it && (it.available || isQuoteSku(it.sku));
      if (!keep) {
        if (el.isConnected) el.remove();
        if (h) delete protoExtraHandles[h];
      }
      return keep;
    });
  }
  function ensureProtocol(pdp) {
    var pairs = pdp.querySelector('.fv3-pairs');
    if (!pairs) return;
    var h = pairs.querySelector('h3');
    if (h && h.textContent !== 'Complete The Protocol') h.textContent = 'Complete The Protocol';
    var buy = pdp.querySelector('.fv3-buy');
    if (buy && pairs.parentNode !== buy) buy.appendChild(pairs);
    var rail = pairs.querySelector('.fv3-pairs-row');
    if (rail && !rail.hasAttribute('tabindex')) {
      rail.setAttribute('role', 'region');
      rail.setAttribute('aria-label', 'Complete The Protocol');
      rail.setAttribute('tabindex', '0');
    }
    if (rail) {
      hideAlternatives(pdp, indexByHandle);
      buildProtoExtras(indexByHandle);
      pruneProtoCards(indexByHandle);
      if (protoExtras) protoExtras.forEach(function (el) { if (!el.isConnected) rail.appendChild(el); });
    }
  }

  /* ---- Recommended For You ---- */
  var recSection = null;
  var fetched = false;

  function uniq(arr) {
    var seen = {}, out = [];
    (arr || []).forEach(function (x) { if (x && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }
  function fetchSignals() {
    return fetch('/?section_id=filtrous-recs-signals')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-fv3-recs-signals[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return null;
        try { return JSON.parse(m[1]); } catch (e) { return null; }
      })
      .catch(function () { return null; });
  }
  /* 2026-09-15 (Adelaide): the "Hazmat Fees" cart-fee product (SKU HAZMAT,
     type mw_hidden_cart_fee) comes back from Shopify's recommendations for
     some solvents. It belongs in the cart only, never in a product rail. */
  function isFeeProduct(p) {
    var v = (p && p.variants && p.variants[0]) || {};
    return String(v.sku || (p && p.sku) || '').toUpperCase() === 'HAZMAT' ||
      (p && p.type) === 'mw_hidden_cart_fee' || /^hazmat-fee/i.test(String((p && p.handle) || ''));
  }
  function fetchIntent(intent) {
    return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return ((j && j.products) || []).filter(function (p) { return !isFeeProduct(p); }); })
      .catch(function () { return []; });
  }
  function renderRec(list) {
    recSection = document.createElement('section');
    recSection.className = 'fv3-rec';
    recSection.setAttribute('aria-label', 'Recommended products');
    var head = document.createElement('div');
    head.className = 'fv3-rv-head';
    var h2el = document.createElement('h2');
    h2el.textContent = 'Recommended For You';
    head.appendChild(h2el);
    recSection.appendChild(head);
    var rail = document.createElement('div');
    rail.className = 'fv3-rv-rail';
    rail.setAttribute('role', 'region');
    rail.setAttribute('aria-label', 'Recommended For You');
    rail.setAttribute('tabindex', '0');
    /* Filtered again at render: the session cache and the localStorage winner
       can hold an arrangement saved before the fee filter existed. */
    list.filter(function (o) { return !isFeeProduct(o); })
      .forEach(function (o) { rail.appendChild(card(o, o.badge || null)); });
    recSection.appendChild(rail);
    arrange();
  }
  function fetchRecs() {
    if (fetched || !pid) return;
    if (!document.querySelector('#fv3-app .fv3-pdp')) return;
    fetched = true;
    var cached = HANDLE ? loadCache('rec', HANDLE) : null;
    if (cached) { renderRec(cached); return; }
    var idx = new Promise(function (res) {
      onIndex(res);
      setTimeout(function () { res(indexByHandle); }, 5000);
    });
    Promise.all([fetchIntent('related'), fetchIntent('complementary'), fetchSignals(), idx])
      .then(function (rr) { assemble(rr[0], rr[1], rr[2], rr[3]); });
  }
  function assemble(related, complementary, signals, map) {
    var pdp = document.querySelector('#fv3-app .fv3-pdp');
    if (!pdp) return;
    var seen = {};
    [].slice.call(pdp.querySelectorAll('.fv3-pairs a[href*="/products/"]')).forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (m) seen[m[1]] = 1;
    });
    Object.keys(protoExtraHandles).forEach(function (h) { seen[h] = 1; });
    if (HANDLE) seen[HANDLE] = 1;
    var rvList = [];
    try { rvList = JSON.parse(localStorage.getItem('fv3-recently-viewed-v1') || '[]'); } catch (e) {}
    rvList.forEach(function (e) { if (e && e.handle) seen[e.handle] = 1; });
    var purchased = (signals && signals.purchased_handles) ? uniq(signals.purchased_handles) : [];
    purchased.forEach(function (h) { seen[h] = 1; });

    var curIt = map ? map[HANDLE] : null;
    var curFam = (curIt && curIt.primary_family) || '';

    var upsells = pickUpsells(map, curIt, seen, 2);
    var have = {};
    upsells.forEach(function (it) { have[it.handle] = 1; });

    var candidates = [];
    function push(c, rank) {
      if (!c.handle || seen[c.handle] || have[c.handle]) return;
      if (curFam && map && map[c.handle] && (map[c.handle].primary_family || '') === curFam) return;
      have[c.handle] = 1;
      c.rank = rank;
      candidates.push(c);
    }
    related.forEach(function (p, i) { push(normApi(p), i); });
    complementary.forEach(function (p, i) { push(normApi(p), 100 + i); });

    var aff = {};
    function add(fams, w) { (fams || []).forEach(function (f) { aff[f] = (aff[f] || 0) + w; }); }
    if (map) {
      purchased.forEach(function (h) { var it = map[h]; if (it) add(it.families, 3); });
      rvList.forEach(function (e) { var it = e && map[e.handle]; if (it) add(it.families, 2); });
      var beh = loadAff();
      Object.keys(beh).forEach(function (f) { aff[f] = (aff[f] || 0) + Math.min(beh[f], 10); });
      var hasSignals = Object.keys(aff).length > 0;
      if (hasSignals) {
        var top = Object.keys(aff).sort(function (a, b) { return aff[b] - aff[a]; })
          .filter(function (f) { return f !== curFam; }).slice(0, 3);
        var topSet = {};
        top.forEach(function (f) { topSet[f] = 1; });
        var perFam = {};
        for (var h in map) {
          var it = map[h];
          if (!it || !it.available || seen[h] || have[h]) continue;
          var pf = it.primary_family;
          if (!topSet[pf] || (perFam[pf] || 0) >= 2) continue;
          perFam[pf] = (perFam[pf] || 0) + 1;
          push(normIdx(it), 200 + top.indexOf(pf) * 10 + perFam[pf]);
        }
      } else if (curFam && WORKFLOW[curFam]) {
        var comps = WORKFLOW[curFam], perFam2 = {};
        for (var h2 in map) {
          var it2 = map[h2];
          if (!it2 || !it2.available || seen[h2] || have[h2]) continue;
          var pf2 = it2.primary_family;
          if (comps.indexOf(pf2) === -1 || (perFam2[pf2] || 0) >= 1) continue;
          perFam2[pf2] = 1;
          push(normIdx(it2), 300 + comps.indexOf(pf2));
        }
      }
    }

    candidates.forEach(function (c) {
      var s = 0, it = map && map[c.handle];
      if (it) (it.families || []).forEach(function (f) { s += aff[f] || 0; });
      c.score = s;
    });
    candidates.sort(function (a, b) { return b.score - a.score || a.rank - b.rank; });
    function famOf(c) { return (map && map[c.handle] && map[c.handle].primary_family) || ''; }
    var list = upsells.map(withBadge);
    var famCount = {};
    upsells.forEach(function (it) { var f = it.primary_family; if (f) famCount[f] = (famCount[f] || 0) + 1; });
    for (var i = 0; i < candidates.length && list.length < 6; i++) {
      var c = candidates[i], pf3 = famOf(c);
      if (pf3) {
        if ((famCount[pf3] || 0) >= 2) continue;
        famCount[pf3] = (famCount[pf3] || 0) + 1;
      }
      list.push({ handle: c.handle, title: c.title, image: c.image, cents: c.cents, sku: c.sku, badge: null });
    }
    if (!list.length) return;
    if (HANDLE) saveCache('rec', HANDLE, list);
    renderRec(list);
  }

  /* ---- order below the grid ---- */
  function arrange() {
    var pdp = document.querySelector('#fv3-app .fv3-pdp');
    if (!pdp) return;
    if (recSection) {
      var grid = pdp.querySelector('.fv3-pdp-grid');
      if (grid && recSection.previousElementSibling !== grid) pdp.insertBefore(recSection, grid.nextSibling);
      else if (!grid && !recSection.isConnected) pdp.appendChild(recSection);
    }
    var rv = pdp.querySelector('.fv3-rv');
    if (rv && rv !== pdp.lastElementChild) pdp.appendChild(rv);
  }

  function run() {
    var pdp = document.querySelector('#fv3-app .fv3-pdp');
    if (!pdp) return;
    ensureTabs(pdp);
    ensureProtocol(pdp);
    fetchRecs();
    arrange();
    ensureArrows(pdp);
    ensureQuickViewBars(pdp);
  }

  function boot() {
    run();
    var host = document.getElementById('fv3-app') || document.body;
    new MutationObserver(run).observe(host, { childList: true, subtree: true });
    onIndex(function () { run(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
